import { render, staticRenderFns } from "./UpdateApp.vue?vue&type=template&id=896deb02&scoped=true"
import script from "./UpdateApp.vue?vue&type=script&lang=js"
export * from "./UpdateApp.vue?vue&type=script&lang=js"
import style0 from "./UpdateApp.vue?vue&type=style&index=0&id=896deb02&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896deb02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('896deb02')) {
      api.createRecord('896deb02', component.options)
    } else {
      api.reload('896deb02', component.options)
    }
    module.hot.accept("./UpdateApp.vue?vue&type=template&id=896deb02&scoped=true", function () {
      api.rerender('896deb02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/settings/UpdateApp.vue"
export default component.exports